export default __webpack_public_path__ + "static/media/upsy-daisy.b6b9c1c7.png";